import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

interface Props {
  stringDate: string
  formats: string[]
}

const validateStringDate = ({ stringDate, formats }: Props) => {
  const isValid = moment(stringDate, formats, true).isValid()

  const message = isValid
    ? ''
    : i18n.t('importer_process.edition_step.validators.date', { format: formats[0] })

  return { isValid, message }
}

export default validateStringDate
